import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-action-buttons',
  templateUrl: './action-buttons.component.html',
  styleUrls: ['./action-buttons.component.scss'],
})
export class ActionButtonsComponent implements OnInit {
  @Input() updateTitle: any;
  @Input() deleteTitle: any;
  @Input() updateIcon: any;
  @Input() deleteIcon: any;
  @Input() updateColor: any;
  @Input() deleteColor: any;
  @Input() formData: any = {};
  @Input() updateDisabled = false;
  @Input() deleteDisabled = false;
  @Input() showUpdateBtn = true;
  @Input() showDeleteBtn = true;
  @Output() updateFunction = new EventEmitter();
  @Output() deleteFunction = new EventEmitter();

  constructor() { }

  ngOnInit(): void { }

  update() {
    this.updateFunction.emit(this.formData);
  }
  remove() {
    this.deleteFunction.emit(this.formData);
  }
}
